import useFunnelNavigation from '@/hooks/useFunnelNavigation';

const GoToQuizButton = ({ className = '', funnelId = null, ...props }) => {
  const { navigateToQuiz } = useFunnelNavigation();

  return (
    <button
      onClick={() => navigateToQuiz(1, funnelId ? { funnelId } : {})}
      className={`bg-[#333] text-white font-semibold rounded-2xl flex items-center justify-center gap-2 px-6 py-4 hover:bg-[#222] transition-colors ${className}`}
      {...props}
    >
      Get my job matches now
    </button>
  );
};

export default GoToQuizButton;
